import { findSubject, subjectsLength } from '@/store/subjects/getters'
import { del, get, getAll, patch, post } from '@/utils/api'

const normalizeSubject = record => ({
  id: record.getId(),
  name: record.get('name'),
  color: record.get('color')
})

const getSubjects = ({ commit, state }, force) => {
  if (subjectsLength(state) < 1 || !!force) {
    getAll('Subjects').then(subjects => {
      const returnSubjects = subjects.map(s => normalizeSubject(s))
      commit('SET_SUBJECTS', returnSubjects)
      commit('IS_LOADED')
    })
  }
}

const getSubject = ({ commit }, id) => {
  const subjectFromState = findSubject(id)
  if (subjectFromState) {
    return subjectFromState
  }

  get('Subjects', id).then(subject => {
    commit('SET_SUBJECT', normalizeSubject(subject))
  })
}

const addSubject = ({ commit }, subject) => {
  post('Subjects', { fields: subject }).then(subjects => {
    subjects.forEach(s => {
      commit('ADD_SUBJECT', normalizeSubject(s))
    })
  })
}

const deleteSubject = ({ commit }, id) => {
  del('Subjects', id).then(s => {
    commit('DELETE_SUBJECT', s.id)
  })
}

const editSubject = ({ commit }, subject) => {
  patch('Subjects', subject).then(s => {
    commit('EDIT_SUBJECT', normalizeSubject(s))
  })
}

export default {
  addSubject,
  deleteSubject,
  editSubject,
  getSubject,
  getSubjects
}
